import { render, staticRenderFns } from "./resetPasswords.vue?vue&type=template&id=9b3af504&scoped=true"
import script from "./resetPasswords.vue?vue&type=script&lang=js"
export * from "./resetPasswords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3af504",
  null
  
)

export default component.exports